import { Checkpoint } from './checkpoint';
import { ContentId } from './content-block';

// maps content id of checkpoint to checkpoint object
export type Checkpoints = Readonly<{ [key: number]: Checkpoint }>;

// We only store the content ids since they will not change while editing the form. The
// other properties can get changed, and we want to force getting the current
// state from the store when dealing with the dependent functional element.
export type CheckpointDependency = Readonly<{ checkpoint: ContentId; functionalElement: ContentId }>;

// The key of this object is the xmlId of the checkpoint.
export type CheckpointDependencies = Readonly<{
    [key: string]: undefined | CheckpointDependency;
}>;

export const initialCheckpoints = {};
export const initialCheckpointDependencies = {};
